export const MACHINE_VIN_UPDATED_EVENT = 'machineVinUpdated';
export const INACTIVITY_EVENT = 'inactivityEvent';
export const MACHINE_ADDED_EVENT = 'machineAdded';
